import { render, staticRenderFns } from "./HeadTipsBtn.vue?vue&type=template&id=59d9d2ae&scoped=true"
import script from "./HeadTipsBtn.vue?vue&type=script&lang=js"
export * from "./HeadTipsBtn.vue?vue&type=script&lang=js"
import style0 from "./HeadTipsBtn.vue?vue&type=style&index=0&id=59d9d2ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d9d2ae",
  null
  
)

export default component.exports